module.exports = __webpack_public_path__ + "images/mirovni_studiji_21_SD_web-27ce2a5a8ce0166bbaf793f91df7e771.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/mirovni_studiji_21_SD_web.png
// module id = 12
// module chunks = 0